export default __webpack_public_path__ + "static/night_ctaModule_table_desktop-7e649f2f59591d50864975ffa1d34b3e.webp";